// extracted by mini-css-extract-plugin
export default {"searchEvent":"OKawkbNYjVl44p6Twf4Q"};